var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "content",
      class: { "theme-red": _vm.roleId === 5 || _vm.roleId === 7 },
    },
    [
      _c("div", {
        staticClass: "mobile-overlay",
        class: [
          {
            "display-Block": _vm.displaySide,
            "display-none": !_vm.displaySide,
          },
        ],
        on: {
          click: function ($event) {
            _vm.displaySide = false
          },
        },
      }),
      _vm.roleId
        ? _c("header-nav", {
            attrs: {
              accountsList: _vm.accountsList,
              roleId: _vm.roleId,
              userCompany: _vm.userCompany,
              displaySide: _vm.displaySide,
              account_id: _vm.account_id,
              editDashboard: _vm.editDashboard,
              account_type_id: _vm.account_type_id,
            },
            on: {
              mobilesidebar: _vm.mobilesidebar,
              accountSettingsPopUpClose: _vm.accountSettingsPopUpClose,
            },
          })
        : _vm._e(),
      _vm.roleId
        ? _c("header-menu", {
            attrs: {
              roleId: _vm.roleId,
              accountId: _vm.account_id,
              displaySide: _vm.displaySide,
              isDashboardCustomizable: _vm.isDashboardCustomizable,
              account_type_id: _vm.account_type_id,
            },
            on: {
              mobilesidebar: _vm.mobilesidebar,
              openDashboardEdit: _vm.openDashboardEdit,
            },
          })
        : _vm._e(),
      _vm.online
        ? [
            _vm.roleId
              ? _c("router-view", {
                  attrs: {
                    roleId: _vm.roleId,
                    account_id: _vm.account_id,
                    userId: _vm.userId,
                    account_type_id: _vm.account_type_id,
                  },
                })
              : _vm._e(),
          ]
        : _c(
            "div",
            { staticClass: "content-wrappper" },
            [_c("network-connection")],
            1
          ),
      _c("progress-bar", {
        attrs: {
          showHelp: _vm.showHelp,
          progressTitleStatus: _vm.progressTitleStatus,
          progressStatus: _vm.progressStatus,
          percentage: _vm.percentage,
          progressTitle: _vm.progressTitle,
        },
        on: { updateProgressStatus: _vm.updateProgressStatus },
      }),
      _c("timeout-warning"),
      _c("team-member-restriction"),
      _c("service-not-added-popup"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }